// NATIVE 


// INSTALLED 

// CUSTOM 
import { AxiosAdapter } from "../commons/adapters";


const http = new AxiosAdapter();


export const setDepartamentsByIdService = async(departament_id:string) => {
   
    try {
        
        return await http.get<any>(`/v1/departament/${departament_id}`); 

    } catch (error) {
        console.log('tonkaaaaaaaaaaaaaaaaaa ',error)
    }
}